import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getLastNonScollTrackingContentBlock({ content }: Props) {
  let lastBlock;
  let i = content.contentBlocks.length;

  const setLastBlock = () => {
    lastBlock =
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      content.contentBlocks && content.contentBlocks.length
        ? content.contentBlocks[i]
        : null;
  };

  setLastBlock();

  // @ts-expect-error TS(2339): Property 'type' does not exist on type 'never'.
  while (lastBlock && lastBlock.type === 'SCROLL_TRACKING') {
    i -= 1;
    setLastBlock();
  }

  return lastBlock;
}
